export default __webpack_public_path__ + "static/media/IMG-20211128-WA0004.1a20bf28.jpg";